//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets firmware data from bucharest.
 * @param generation (optional) 
 * @param targetLanguage (optional) 
 */
export function get(generation?: string | null | undefined, targetLanguage?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FwResponseDto[]> {
    let url_ = getBaseUrl() + "/api/fw?";
    if (generation !== undefined && generation !== null)
        url_ += "generation=" + encodeURIComponent("" + generation) + "&";
    if (targetLanguage === null)
        throw new Error("The parameter 'targetLanguage' cannot be null.");
    else if (targetLanguage !== undefined)
        url_ += "targetLanguage=" + encodeURIComponent("" + targetLanguage) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGet?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGet(_response);
    });
}

function processGet(response: AxiosResponse): Promise<Types.FwResponseDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initFwResponseDto(item)
              );
            }
        return Promise.resolve<Types.FwResponseDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FwResponseDto[]>(null as any);
}

/**
 * Gets firmware download link.
 * @param generation (optional) 
 * @param subtype (optional) 
 * @param getOlderVersion (optional) 
 */
export function getLink(generation?: string | undefined, subtype?: string | undefined, getOlderVersion?: boolean | null | undefined, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/fw/link?";
    if (generation === null)
        throw new Error("The parameter 'generation' cannot be null.");
    else if (generation !== undefined)
        url_ += "generation=" + encodeURIComponent("" + generation) + "&";
    if (subtype === null)
        throw new Error("The parameter 'subtype' cannot be null.");
    else if (subtype !== undefined)
        url_ += "subtype=" + encodeURIComponent("" + subtype) + "&";
    if (getOlderVersion !== undefined && getOlderVersion !== null)
        url_ += "getOlderVersion=" + encodeURIComponent("" + getOlderVersion) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetLink,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetLink?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetLink(_response);
    });
}

function processGetLink(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}
let _requestConfigGet: Partial<AxiosRequestConfig> | null;
export function getGetRequestConfig() {
  return _requestConfigGet;
}
export function setGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGet = value;
}
export function patchGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGet = patch(_requestConfigGet ?? {});
}

let _requestConfigGetLink: Partial<AxiosRequestConfig> | null;
export function getGetLinkRequestConfig() {
  return _requestConfigGetLink;
}
export function setGetLinkRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetLink = value;
}
export function patchGetLinkRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetLink = patch(_requestConfigGetLink ?? {});
}